import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useFetchLoV = ({
  codigo_lv,
  campo,
  expediente,
  busqueda = '',
  page = 1,
  limit = 12,
  informe,
  programa,
  bloque,
  filtros = [],
}) => {
  const [response, setResponse] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState()

  const fetchData = () => {
    if (loading) return
    setLoading(true)

    axios
      .post(`/getLOV/`, {
        codigo_lv,
        campo,
        expediente,
        busqueda,
        filtros,
        page,
        limit,
        informe,
        programa,
        bloque,
      })
      .then((request_response) => {
        setResponse(request_response.data)
        setError(null)
      })
      .catch((request_error) => setError(request_error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!loading) fetchData()
  }, [busqueda, page])

  return { response, error, loading }
}

export default useFetchLoV
